import Axios from "axios";
import { message } from "antd";

export default function deleteCompany(_id, filterCompaniesDeletion) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "DELETE",
      url: `${process.env.REACT_APP_BASE_URL}/delete-company/${_id}`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then(() => {
        filterCompaniesDeletion(_id);
        return dispatch({
          type: "Loading",
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
        message.error("Something Went Wrong Please try again Later");
      });
  };
}
